/** The exact R-5.1 wording. Keep in sync with CALC_DISCLAIMER in @seventide/content. */
export const CALC_DISCLAIMER_TEXT =
  'This is a calculation based on the information you entered and the published rules. It is not advice.';
